import axios from '../Axios';

export default {
    async getProducts(filters = {}, page = 1, perPage = 10) {
        try {
            const response = await axios.get('/products', {
                params: { resource: 'list', dashboard: 1, page, per_page: perPage, ...filters }
            });
            const resData = response.data;
            console.log('Full response:', resData);
            // data might be nested: resData.data.data (Laravel ResourceCollection with pagination)
            let products = resData.data;
            if (products && !Array.isArray(products) && Array.isArray(products.data)) {
                products = products.data;
            }
            return {
                data: Array.isArray(products) ? products : [],
                total: resData.meta?.total || resData.data?.meta?.total || 0,
                currentPage: resData.meta?.current_page || resData.data?.meta?.current_page || 1,
                lastPage: resData.meta?.last_page || resData.data?.meta?.last_page || 1
            };
        } catch (error) {
            console.error("Failed to fetch Products:", error);
            throw error;
        }
    },

    async getProduct(id) {
        try {
            const response = await axios.get(`/products/${id}`);
            return response.data.data;
        } catch (error) {
            console.error("Failed to fetch product:", error);
            throw error;
        }
    },

    async createProduct(data) {
        try {
            const response = await axios.post('/products', data);
            return response.data.data;
        } catch (error) {
            console.error("Failed to create product:", error);
            throw error;
        }
    },

    async updateProduct(id, data) {
        try {
            const response = await axios.post(`/products/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error("Failed to update product:", error);
            throw error;
        }
    },

    async deleteProduct(id) {
        try {
            const response = await axios.delete(`/products/${id}`);
            return response.data;
        } catch (error) {
            console.error("Failed to delete product:", error);
            throw error;
        }
    }
}

// export default new ProductService();
